export class CheckRollnoData {
    public rollno: string;
    public clgcode: string;
    public hashData: string;
    constructor() {
        this.rollno = '';
        this.clgcode = '';
    }
}
